import React from "react"
import EditorialMethodPage from "../../templates/hotels/EditorialMethodPage"

const Page = () => <EditorialMethodPage locale="en" />

export default Page
